import { Errors } from '@/common/Errors';

class GrpcWebErrorHandler {
  static handleGrpcWebError(error) {
    // Check if the error is a gRPC-Web error
    if (error.code !== undefined) {
      console.log(error)
      try {
        const grpc_err = JSON.parse(error.message)
        return {
          code: grpc_err["error_code"],
          summary: Errors[grpc_err["error_code"]] ? Errors[grpc_err["error_code"]]["error_name"] : "Error",
          detail: Errors[grpc_err["error_code"]] ? Errors[grpc_err["error_code"]]["error_message"] : grpc_err["error_message"] || error.message,
          args: grpc_err.args
        }
      } catch (e) {
        // message is not JSON
        return {
          code: error.code,
          summary: "Network Error",
          detail: error.message,
          args: []
        }
      }
    }
    return error;
  }
}


export default GrpcWebErrorHandler;
